import { t } from "i18next";
import React from "react";
import { useDispatch } from "react-redux";
import { CasinoIconGameType } from "../../../common/types/Casino/CasinoIconGameType";
import { FavoritCasinoResponceType } from "../../../common/types/Casino/FavoritCasinoResponceType";
import { FavoritCasinoStateType } from "../../../common/types/Casino/FavoritCasinoStateType";
import { useTypeSelector } from "../../../hooks/useTypeSelector";
import { CasinoInfo } from "../../../services";

import "./GameItem.scss";
import {
  setFavoritsUser,
  setFavoritsLocalSelect,
  setFavoritsLocalDelete,
} from "../../../store/reducers/favoritsReducer";
import { setModalPopap, setModalLogin } from "../../../store/reducers/modalsReducer";
import { useParams } from "react-router-dom";

interface IGameItem {
  item: CasinoIconGameType | FavoritCasinoStateType | FavoritCasinoResponceType;
  checkedGame: number;
  wrapperRef: React.MutableRefObject<null>;
  handleCheckItem: (item: number) => void;
  liveCasino?: boolean;
}
const GameItem = ({
  item,
  checkedGame,
  handleCheckItem,
  liveCasino,
}: IGameItem) => {
  const { en } = useParams();
  const { user } = useTypeSelector((data) => data.accountInfoReducer);
  const role = useTypeSelector((data) => data.accountInfoReducer.role);
  const favoritsGamesUser = useTypeSelector(
    (data) => data.favoritsReducer.favoritCasinoUser
  );
  const favoritsGamesLocal = useTypeSelector(
    (data) => data.favoritsReducer.favoritCasinoLocal
  );
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  function openOutside(url: string) {
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      window.location.href = url;
    } else {
      window.open(url, "_blank");
    }
  }
  async function searchPlay() {
    try {
      const gameUrl = `/${item.game_provider.slug}/${item.slug}?currency=TRY&lang=${en}&platform=desktop&game_link=true`;
      const res = token
        ? await CasinoInfo.casinoPlay(gameUrl)
        : await CasinoInfo.casinoPlayDemo(gameUrl);
      const url = res.data.game_link;
      let hasError = 0;
      if (res.data.error) {
        hasError = Object.keys(res.data.error).length;
      }
      if (
        // user.extra_data.softswiss_freespin &&
        user.active_bonus?.settings.freespin_games &&
        res.data.has_freespins
      ) {
        const launchCode = res.data.launch_code;
        const freespinGames = user.active_bonus.settings.freespin_games;
        if (url) {
          if (freespinGames.some((game: string | string[]) => game.includes(launchCode))) {
            await CasinoInfo.casinoPlayFreespins(launchCode);
            openOutside(url);
          } else {
            openOutside(url);
          }
        } else if (hasError) {
          // If there is no game link and there is an error
          alert(res.data.error.message);
        }
      } else {
        if (url) {
          if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            window.location.href = url;
          } else {
            window.open(url, "_blank");
          }
        } else if (hasError) {
          // If there is no game link and there is an error
          alert(res.data.error.message);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function searchPlayDemo() {
    try {
      const res = await CasinoInfo.casinoPlayDemo(
        `/${item.game_provider.slug}/${item.slug}?currency=TRY&lang=${en}&platform=desktop&game_link=true`
      );

      const url = res.data.game_link;

      if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        window.location.href = url;
      } else {
        window.open(url, "_blank");
      }
    } catch (error) {
      console.error("Ошибка при получении игровой ссылки:", error);
    }
  }
  const handleOpenDemo = () => {
    searchPlayDemo();
  };
  const handleOpenPlay = () => {
    if (role === "player") {
      searchPlay();
    } else {
      dispatch(setModalPopap(true));
      dispatch(setModalLogin(true));
    }
  };
  const handleFavoriteUserSelect = () => {
    async function gandleSelectFavorit() {
      await CasinoInfo.setFavoriteGame({
        game_id: item.id,
        type: 1,
      });
      const res = await CasinoInfo.favoriteGames();
      dispatch(setFavoritsUser(res.data));
    }
    async function gandleRemoveFavorit() {
      await CasinoInfo.setFavoriteGame({
        game_id: item.id,
        type: 0,
      });
      const res = await CasinoInfo.favoriteGames();
      dispatch(setFavoritsUser(res.data));
    }
    favoritsGamesUser.some((obj) => obj.id === item.id)
      ? gandleRemoveFavorit()
      : gandleSelectFavorit();
  };
  const handleFavoriteLocalSelect = () => {
    async function gandleSelectFavorit() {
      dispatch(
        setFavoritsLocalSelect({
          id: item.id,
          slug: item.slug,
          original_name: item.original_name,
          is_demo_enabled: item.is_demo_enabled,
          game_provider: {
            slug: item.game_provider.slug,
          },
          banner: item.banner,
        })
      );
    }
    async function gandleRemoveFavorit() {
      dispatch(
        setFavoritsLocalDelete({
          id: item.id,
          slug: item.slug,
          original_name: item.original_name,
          is_demo_enabled: item.is_demo_enabled,
          game_provider: {
            slug: item.game_provider.slug,
          },
          banner: item.banner,
        })
      );
    }
    favoritsGamesLocal.some((obj) => obj.id === item.id)
      ? gandleRemoveFavorit()
      : gandleSelectFavorit();
  };
  return (
    <div
      className="casino-game-item-content"
      onClick={() => handleCheckItem(item.id)}
    >
      <div className="casino-game-item  " data-badge="">
        <img
          src={item.banner.cloudflare}
          className="casino-game-item-image-bc"
          alt={item.original_name}
          title={item.original_name}
          loading="eager"
        />
        {checkedGame === item.id ? (
          <div className="casino-game-item-block">
            <div className="casino-game-icons">
              <i className="casino-game-info-icon bc-i-info" />
            </div>
            <h3 className="casino-game-item-label-bc">{item.original_name}</h3>
            <div className="casino-game-buttons">
              <button
                className="btn a-color "
                type="button"
                title="Play"
                onClick={handleOpenPlay}
              >
                <span>{t("casino.Play")}</span>
              </button>
              {item.is_demo_enabled && !liveCasino ? (
                <button
                  className="btn a-outline "
                  type="button"
                  title="Demo"
                  onClick={handleOpenDemo}
                >
                  <span>{t("casino.Demo")}</span>
                </button>
              ) : null}
            </div>
          </div>
        ) : null}

        {role === "player" ? (
          <i
            className={`casino-game-item-fav-bc bc-i-favorite ${
              favoritsGamesUser.some((obj) => obj?.id === item?.id)
                ? "active"
                : "null"
            }`}
            onClick={handleFavoriteUserSelect}
          />
        ) : (
          <i
            className={`casino-game-item-fav-bc bc-i-favorite ${
              favoritsGamesLocal.some((obj) => obj?.id === item?.id)
                ? "active"
                : "null"
            }`}
            onClick={handleFavoriteLocalSelect}
          />
        )}
      </div>
    </div>
  );
};

export { GameItem };
